import FilesIcons from "@common-components/files-icons/filesIcons";
import { mediaManager } from "@common-reducers/MediaManagerReducer";
import { pickerDialogActions } from "@common-reducers/PickerDialogReducer";
import { NullableId } from "@common/types/interface";
import { useAppDispatch } from "@common-reducers/hooks/store.hook";
import { Box, Stack } from "@mui/material";
import { memo, MouseEvent, useEffect, useState } from "react";

type FileItem = { _id?: string; url?: string; type?: string; filename?: string };

interface Props {
    values: unknown[];
    columnId: NullableId;
    groupId: NullableId;
}
function FilesSumCell({
    values: filesRaw,
    columnId,
    groupId
}: Props) {
    const files = (filesRaw ?? []) as FileItem[];
    const dispatch = useAppDispatch()
    const [delayHandler, setDelayHandler] = useState<ReturnType<typeof setTimeout> | null>(null);
    const anchorId = `filesSum_${columnId}`
    function hoverFile(i: number) {
        if (files.length === 1) return;
        setDelayHandler(
          setTimeout(() => {
            dispatch(
              pickerDialogActions.setPickerTypeAndId({
                pickerAnchorId: anchorId,
                pickerProps: {
                  cellValue: files,
                  columnId: columnId ?? undefined,
                  taskId: files[i]?._id,
                  groupId: groupId ?? undefined,
                  type: 'files'
                }
              })
            );
          }, 300)
        );
      }


    const handleMouseLeave = () => {
        if (delayHandler) clearTimeout(delayHandler);
    };

    useEffect(() => {
        return () => {
            if (delayHandler) clearTimeout(delayHandler);
        };
    }, [delayHandler]);

    function openMediaManager(e: MouseEvent<HTMLDivElement>, i: number, files: FileItem[]) {
        e.stopPropagation();
        const currentFilesAndIndex = {
            index: i,
            shown: true,
            taskId: files[i]._id,
            columnId,
            filesTotal: files,
            isViewOnly: true,
        };
        dispatch(
            mediaManager.setSelectedCellFilesAndCurrentindex(currentFilesAndIndex)
        );
        dispatch(pickerDialogActions.closePickerDialog());
    }
    return (
        <Stack id={`filesSum_${columnId}`} direction="row" alignItems={"center"} flexGrow={1} justifyContent={"center"}
            sx={{ background: 'var(--color-surface)', height: "80%", padding: "0 10px",position:"relative"}} >
            {files?.slice(0, 3).map((file: FileItem, i: number) => {
                return (
                    <Stack sx={{padding:"0 2px;"}} key={i}
                    onMouseEnter={()=>hoverFile(i)}
                    onMouseLeave={handleMouseLeave}
                        onClick={(e) => {
                            openMediaManager(e, i, files);
                        }}
                    >
                        <FilesIcons file={file} />
                    </Stack>
                );
            })}

            {files?.length > 3 && (
                <Box
                sx={{height:'20px',width:'20px',background: "var(--color-primary)",display:'flex',color:"var(--color-surface)",fontSize:"10px",alignItems:"center",justifyContent:"center",borderRadius:"50%",marginTop:"2px",position: "absolute",right:"2px",top:"1px"}}
                onMouseEnter={()=>hoverFile(0)}

                    onMouseLeave={handleMouseLeave}
                   >
                    +{files.length - 3}
                </Box>
            )}
        </Stack>
    );
}

export default memo(FilesSumCell)